export default httpClient => ({
  save: async ({ status, nome, link_ios, link_android, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/jogos-educativos', { status, nome, link_ios, link_android }, { headers })
    return {
      data: response.data,
    }
  },
  update: async ({ id, status, nome, link_ios, link_android, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.patch('/jogos-educativos/' + id, {
      status, nome, link_ios, link_android,
    }, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/jogos-educativos/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/jogos-educativos', { headers });
    return { data: response.data }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/jogos-educativos/' + id, { headers });
    return {
      data: response
    }
  },
});